import { render, staticRenderFns } from "./endPointMgr.vue?vue&type=template&id=12d9db0a&"
import script from "./endPointMgr.vue?vue&type=script&lang=js&"
export * from "./endPointMgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports